import { useCallback } from 'react';
import {
  resetShutdownFilterValues,
  setChosenShutdownFilter,
} from '../../model/actions';
import useChangeDefaultFilter from '../../../../shared/api/mutation/useChangeDefaultFilter';
import useChooseFilter from '../../../../shared/hooks/useChooseFilter';
import { useDispatch, useSelector } from 'react-redux';
import useDeleteFilter from '../../../../shared/api/mutation/useDeleteFilter';
import { selectChosenFilterId } from '../../model/selectors';
import useSavedFiltersQuery from '../../../../shared/api/queries/useSavedFiltersQuery';
import { Modal } from 'antd';
import { fetchShutdownsThunk } from '../../../../shared/model/actions';

const { confirm } = Modal;

const useSavedFilters = () => {
  const dispatch = useDispatch();

  const chooseFilter = useChooseFilter();
  const { onDeleteFilter, isDeleteFilterLoading } = useDeleteFilter();
  const { onChangeDefaultFilter, isChangeDefaultFilterLoading } =
    useChangeDefaultFilter();

  const chosenFilterId = useSelector(selectChosenFilterId);
  const { data: filters = [], isFetching } = useSavedFiltersQuery();

  const applyFilter = useCallback(
    async (id) => {
      await onChangeDefaultFilter(id);
      await chooseFilter(id);
    },
    [onChangeDefaultFilter, chooseFilter]
  );

  const deleteFilter = useCallback(
    async (id) => {
      await onDeleteFilter(id);
      dispatch(setChosenShutdownFilter({ id: null, name: null }));
    },
    [onDeleteFilter, dispatch]
  );

  const confirmDeleteFilter = useCallback(
    (e, id) => {
      e.preventDefault();
      confirm({
        title: 'Вы действительно хотите удалить этот фильтр?',
        onOk: async () => {
          await deleteFilter(id);
          dispatch(resetShutdownFilterValues());
          dispatch(fetchShutdownsThunk());
        },
      });
    },
    [deleteFilter]
  );

  return {
    filters,
    chosenFilterId,
    isFetching,
    isBusy: isChangeDefaultFilterLoading || isDeleteFilterLoading,
    applyFilter,
    confirmDeleteFilter,
  };
};

export default useSavedFilters;
